module.exports = __webpack_public_path__ + "static/media/ain_ghazal_text_05.9faebd1e.jpg";